module.exports = __webpack_public_path__ + "static/onTheIssues_HealthCare_2-2e1e6a3bff07505c26abf37d3fa222dc.jpg";